import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { OshWave } from '../../../../interfaces/osh/oshWave';

@Component({
  selector: 'osh-wave-selector',
  template: `Wave:<br />
                    <ng-select  
                        style="border: 1px white solid" 
                        class="top-main-select wave-selector"
                        (ngModelChange)="onWaveChange($event)"
                        [items]="waveList"
                        bindLabel="name"
                        bindValue="id"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        [(ngModel)]="selectedWave">
                 </ng-select>`,
  styleUrls: ['../../../../style/mat-table.component.less'],
  standalone: false
})
export class OshWaveSelectorComponent implements OnInit, OnDestroy {

  protected _onDestroy = new Subject<void>();
  waveList: OshWave[] = [];
  selectedWave: number | undefined = -1;
  private lastMgmtId: string = '';

  constructor(
    private readonly http: HttpClient,
    @Inject('BASE_URL') private readonly baseUrl: string,
    public defaults: DefaultValuesService,
    private readonly toastrService: ToastrService
  ) { }

  ngOnInit() {
    if (this.defaults.oshWaveId && this.defaults.oshWaveId > 0) {
      this.selectedWave = this.defaults.oshWaveId;
    }

    if (this.defaults.managementid && this.defaults.managementid !== '-1') {
      this.lastMgmtId = this.defaults.managementid;
      this.getWaveByBranch(this.defaults.managementid);
    }

    this.defaults.managementIdMessageChanges$
      .pipe(debounceTime(300), takeUntil(this._onDestroy))
      .subscribe(() => {
        if (this.defaults.managementid !== this.lastMgmtId) {
          this.lastMgmtId = this.defaults.managementid;
          this.getWaveByBranch(this.defaults.managementid);
        }
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onWaveChange(waveId: number) {
    this.defaults.updateOshWave(waveId);
  }

  getWaveByBranch(mgmtId: string) {
    if (!mgmtId) {
      this.waveList = [];
      this.selectedWave = -1;
      this.defaults.updateOshWave(-1);
      return;
    }

    const url = `${this.baseUrl}api/osh/waves/branch/${mgmtId}`;

    this.http.get<OshWave[]>(url).subscribe({
      next: (waves) => {
        this.waveList = waves;
        if (waves.length > 0) {
          const persistedWaveId = this.defaults.oshWaveId;
          const keepCurrent = waves.some(w => w.id === persistedWaveId);
          const nextWaveId = keepCurrent ? persistedWaveId : waves[0].id;

          this.selectedWave = nextWaveId;

          if (nextWaveId !== persistedWaveId) {
            this.defaults.updateOshWave(nextWaveId);
          }
        } else {
          this.selectedWave = -1;
          this.defaults.updateOshWave(-1);
        }
      },
      error: (error) => {
        this.waveList = [];
        this.selectedWave = -1;
        this.defaults.updateOshWave(-1);

        if (error.status !== 404) {
          this.toastrService.error('Error loading wave information');
        }
      }
    });
  }
}